import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eTraCuuDiemActionIds, ITraCuuDiemActionsType, ITraCuuDiemActionsTypeBase } from "../../action-types/tra-cuu-diem/ITraCuuDiemActionsType";
import { traCuuDiemApi } from "../../../api/tra-cuu-diem/traCuuDiemApi";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";

const mainActions = rootActions.traCuuDiem;

export function* traCuuDiemSaga() {
    yield takeLatest(eTraCuuDiemActionIds.LOAD_TRA_CUU_DIEM_START, loadTraCuuDiemWorker);
}

function* loadTraCuuDiemWorker(action: ITraCuuDiemActionsType) : any {
     const payload = action.payload as ITraCuuDiemActionsTypeBase<string>;
    const res: IBaseResponse = yield call(traCuuDiemApi.SelectTraCuuDiemByMaSv, payload.data);
    if (res.is_success) {
        yield put(mainActions.LOAD_TRA_CUU_DIEM_SUCCESS({
            data: {
                traCuuDiemThiList: toLowerCaseDeep(res.data?.traCuuDiemThiList) ?? [],
                traCuuDiemThanhPhanList: toLowerCaseDeep(res.data?.traCuuDiemThanhPhanList) ?? [],
                traCuuDiemThanhPhanThiList: toLowerCaseDeep(res.data?.traCuuDiemThanhPhanThiList) ?? [],
                traCuuDiemLopHocPhanList: toLowerCaseDeep(res.data?.traCuuDiemLopHocPhanList) ?? [],
                traCuuDiemPhongThiList: toLowerCaseDeep(res.data?.traCuuDiemPhongThiList) ?? [],
            },
            id: payload.id
        }));
    } else {
        yield put(mainActions.LOAD_TRA_CUU_DIEM_ERROR({
            id: payload.id,
            data: res.message ?? "Có lỗi"
        }));
    }
}